import { defineStore } from 'pinia'

import { fetchFollowedTags, followTag, unfollowTag } from 'src/api/tags.js'

// the load that runs now, so that menus opened at once share it
let loading = null

const byName = (a, b) => a.name.localeCompare(b.name)
const same = (a, b) => a.toLowerCase() === b.toLowerCase()

// The hashtags the user follows: their posts come into the home timeline.
export const useFollowedTagsStore = defineStore('followedTags', {
  state: () => ({
    tags: [],
    loaded: false,
  }),
  getters: {
    isFollowed: (state) => (name) => state.tags.some((t) => same(t.name, name)),
  },
  actions: {
    async load() {
      const { data } = await fetchFollowedTags({})
      this.tags = [...data].sort(byName)
      this.loaded = true
    },
    // a load unless one ran or runs; a failed one is tried again next time
    // (servers without followed hashtags answer with an error)
    ensureLoaded() {
      if (this.loaded) return Promise.resolve()
      loading ??= this.load()
        .catch(() => undefined)
        .finally(() => {
          loading = null
        })
      return loading
    },
    async follow(name) {
      const { data } = await followTag({
        name,
      })
      if (!this.isFollowed(data.name)) {
        this.tags = [...this.tags, data].sort(byName)
      }
    },
    async unfollow(name) {
      await unfollowTag({ name })
      this.tags = this.tags.filter((t) => !same(t.name, name))
    },
  },
})
